import Cookies from 'js-cookie';
import { Post } from 'Xhr/Xhr';
import { SetBaseData } from './Functions/SetBaseData';
import { GetUserImage } from '../../../../Global/Adapters/GetUserImage';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { env } from 'env';
export const LoginUser = async (data, navigate) => {
  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_LOGIN}`,
    false,
    data
  )
    .then((response) => {
      if (response.data.resCode === 1) {
        SetBaseData(response, data);
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    })
    .then(() => {
      if (localStorage.getItem('AuthToken') !== null) {
        const data = JSON.parse(Cookies.get('user'));
        GetUserImage({ id: data.Id });
      }
    })
    .then(() => {
      if (localStorage.getItem('AuthToken') !== null) {
        navigate({
          pathname: '/main',
        });
      }
    })
    .catch(() => {});
};
